import { metadata } from './content/helpers';
import { LOCALES } from '../constants';
import { z } from 'zod';

export const faqQuestionSchema = z.object({
  question: z.string(),
  answer: z.string(),
});

export type FaqQuestionInput = z.infer<typeof faqQuestionSchema>;

export const faqSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().min(1).max(100),
  claim_section_id: z.number().positive().nullable(),
  office_id: z.number().positive().nullable(),
  content: z.object({
    metadata: metadata,
    data: z.array(faqQuestionSchema),
  }),
  locale: z.string().refine((locale) => LOCALES.includes(locale), { message: 'Invalid locale' }),
});

export type FaqInput = z.infer<typeof faqSchema>;
